import React from 'react'
import {
  Button,
  OverflowMenuItem,
  OverflowMenu,
  DataTable as CarbonDataTable
} from 'carbon-components-react'

import { Add32, Settings32 } from '@carbon/icons-react'

import defaultActions from './actions'
import { addRow, setQuickFilter } from './helpers'

const { TableToolbarContent, TableToolbarSearch } = CarbonDataTable

const defaultActionDefaulti18nKeys = {
  add: 'add',
  exportCSV: 'csvExport',
  duplicate: 'duplicateRows',
  selectAll: 'selectAll',
  delete: 'deleteRows',
  clearAll: 'clearAll',
  pinRowTop: 'pinRowToTop',
  pinRowBottom: 'pinRowToBottom',
  sizeToFit: 'sizeToFit',
  autoSizeAll: 'autosizeAllColumns',
  autoSizeSkipHeader: 'autosizeAllColumnsSkipHeader'
}

function TableHeader({
  customActions = [],
  columnApi,
  gridApi,
  canAddRows,
  canExportCSV,
  canDuplicate,
  canDeleteRows,
  canClearAll,
  canPinRowTop,
  canPinRowBottom,
  canSelectAll,
  canSearch,
  isSizeToFit,
  isAutoSize,
  isAutoSizeAll,
  onRowAdd,
  onRowDelete,
  localeTextFunc,
  defaultActionsi18nKeys = {},
  customComponent: Component,
  customComponentContainerClassName
}) {
  const actionFlags = {
    canAddRows,
    canExportCSV,
    canDuplicate,
    canDeleteRows,
    canClearAll,
    canPinRowTop,
    canPinRowBottom,
    canSelectAll,
    isSizeToFit,
    isAutoSize,
    isAutoSizeAll
  }

  const actionCallbacks = {
    onRowAdd,
    onRowDelete
  }

  const mergedActionsi18nKeys = {
    ...defaultActionDefaulti18nKeys,
    ...defaultActionsi18nKeys
  }

  const actions = [
    ...defaultActions(actionFlags, actionCallbacks, mergedActionsi18nKeys),
    ...customActions
  ]

  return (
    <div className='ag-grid-table-header container'>
      {canSearch && (
        <div className='header-search'>
          <TableToolbarContent className='search-toolbar'>
            <TableToolbarSearch
              closeButtonLabelText='Clear search input'
              defaultValue=''
              type='text'
              // id='filter-text-box'
              onInput={(event) => setQuickFilter(gridApi, event.target.value)}
              labelText={
                localeTextFunc ? localeTextFunc('searchOoo') : 'Search'
              }
              placeHolderText={
                localeTextFunc ? localeTextFunc('searchOoo') : 'Search'
              }
              name=''
              size='lg'
            />
          </TableToolbarContent>
        </div>
      )}
      {actions.length > 0 && (
        <div className='header-overflowmenu'>
          <OverflowMenu
            ariaLabel='Menu'
            direction='bottom'
            flipped
            renderIcon={Settings32}
            size='lg'
          >
            {actions.map(
              ({ title, onClick, i18nKey, hasDivider, isDelete }) => (
                <OverflowMenuItem
                  type='button'
                  key={title}
                  hasDivider={hasDivider}
                  isDelete={isDelete}
                  itemText={
                    localeTextFunc && i18nKey ? localeTextFunc(i18nKey) : title
                  }
                  onClick={() => onClick(gridApi, columnApi)}
                />
              )
            )}
          </OverflowMenu>
        </div>
      )}
      {canAddRows && (
        <Button
          disabled={false}
          kind='primary'
          onClick={() => addRow(gridApi, {}, onRowAdd)}
          renderIcon={Add32}
          size='default'
          tabIndex={0}
          type='button'
        >
          {localeTextFunc && mergedActionsi18nKeys.add
            ? localeTextFunc(mergedActionsi18nKeys.add)
            : 'Add rows'}
        </Button>
      )}
      {Component && (
        <div className={customComponentContainerClassName}>
          {React.cloneElement(Component, { columnApi, gridApi })}
        </div>
      )}
    </div>
  )
}

export default TableHeader
